// Stain Removal Station - Specialized stain treatment department
import React from 'react';
import { Beaker } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const StainRemovalStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="stain-removal"
      stationName="Stain Removal"
      stationIcon={<Beaker className="w-6 h-6" />}
      stationColor="#EF4444"
      showAdvanceButton={true}
      showCustomerContact={false}
      showDeliveryInfo={false}
    />
  );
};

export default StainRemovalStation;
